import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Item } from './Item';

export enum TranslationLanguage {
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH',
  FRENCH = 'FRENCH',
}

export interface Translation extends Item {
  language: TranslationLanguage;
  text: string;
  translatedText: string;
}

export const translateTranslationForTransport = (attributes: any): any => {
  const { text, translatedText } = attributes;
  return {
    ...attributes,
    text: !isBase64(text) ? base64Encode(text) : text,
    translatedText: !isBase64(translatedText) ? base64Encode(translatedText) : translatedText,
  };
};

export const translateTranslationFromTransport = (attributes: any): any => {
  const { text, translatedText } = attributes;
  return {
    ...attributes,
    text: isBase64(text) ? base64Decode(text) : text,
    translatedText: isBase64(translatedText) ? base64Decode(translatedText) : translatedText,
  };
};
